import gb from '../../assets/icons/flags/svg/gb.svg';
import si from '../../assets/icons/flags/svg/si.svg';
import it from '../../assets/icons/flags/svg/it.svg';
import de from '../../assets/icons/flags/svg/de.svg';
import es from '../../assets/icons/flags/svg/es.svg';
import jp from '../../assets/icons/flags/svg/jp.svg';
import ru from '../../assets/icons/flags/svg/ru.svg';
import cn from '../../assets/icons/flags/svg/cn.svg';

export const languages = [
  {
    code: 'en',
    flag: gb,
    name: 'English (EN)'
  },
  {
    code: 'si',
    flag: si,
    name: 'Slovenia (SI)'
  },
  {
    code: 'de',
    flag: de,
    name: 'Germany (DE)'
  },
  {
    code: 'es',
    flag: es,
    name: 'Spain (ES)'
  },
  {
    code: 'it',
    flag: it,
    name: 'Italy (IT)'
  },
  {
    code: 'jp',
    flag: jp,
    name: 'Japan (JP)'
  },
  {
    code: 'ru',
    flag: ru,
    name: 'Russia (RU)'
  },
  {
    code: 'zh',
    flag: cn,
    name: 'China (ZH)'
  }
];
